import React, { useState } from "react";
import { app } from "../../firebase";
import { Link } from "react-router-dom";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import swal from "sweetalert";


function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const auth = getAuth(app);

  const adminLogin = async (e) => {
    e.preventDefault(e);
    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        // Signed in
        alert("success");
        const user = userCredential
      })
      .catch((error) => {
        swal("Oops!", error.message)
        
      });
  };

  return (
    <>
      <div className="bg-black justify-center items-center h-screen container">
        <div className="row justify-center items-center">
          <div className="col-lg-6 col-md-8 col-sm-10">
            <div className="">
              <div className="justify-center items-center max-w-full text-center mx-auto my-auto pt-20 ">
                <div className="text-white text-3xl">Admin Panel</div>
                <div className="">
                  <form
                    onSubmit={(email, password) => adminLogin(email, password)}
                    className="form-control flex justify-center items-center flex-col gap-3 p-3"
                     >
                    <input
                      className="w-full form-control"
                      type="email"
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="email"
                    />
                    <input
                      className="w-full form-control"
                      type="password"
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="password"
                    />
                    <button
                      type="submit"
                      className="btn btn-success text-black"
                    >
                      Log in
                    </button>
                  </form>
                  <Link to="/"><button  type="submit" className="btn btn-success  text-white mt-5">
                     Back to Homepage
                  </button></Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminLogin;
